enum SpriteType {
  Stone=0,
  Player,
  Monster,
  Gift,
  Transmit
}
export default SpriteType